import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LeaveType, LeaveTypeCreate, LeaveTypeFilter } from '../data/leaveType';

export function createLeaveTypeService(client: AxiosInstance) {
  return createCrudService<LeaveType, LeaveTypeCreate, LeaveTypeFilter>(
    client,
    '/hrm/LeaveType',
    'id',
  );
}

export type LeaveTypeService = CrudService<LeaveType, LeaveTypeCreate, LeaveTypeFilter>;
